export default {
    CalendarStore: {
        SESSION_STORAGE_SUPPORT: {
            eventName: 'sessionStorageSupport',
            customData: (supported: boolean): [boolean] => [supported],
        },
        ADD_CALENDAR: 'AddCalendar',
        CALENDARS_SELECTED_COUNT: 'CalendarsSelectedCount',
        SELECT_DEFAULT_CALENDAR: 'SelectDefaultCalendar',
    },
};
